module.exports = __webpack_public_path__ + "img/002.59c6717a.png";